import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { write, utils } from 'xlsx'
import MUIDataTable from 'mui-datatables'
import Constant, { getCountryTimeZone } from '../../Constant'
import Moment from 'react-moment'
import axios from 'axios'
import Swal from 'sweetalert2'
moment.tz = require('moment-timezone')

const VoucherReport = () => {
  const [filter, setFilters] = useState({
    country: localStorage.getItem('countryShortName') || 'KWT',
    name: '',
    code: '',
    created_by: '',
    redeemed_by: '',
    start_date: '',
    end_date: '',
  })
  const [countries, setCountries] = useState([])
  const [list, setList] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    loadCountries()
    return () => {}
  }, [])

  const loadVoucherHistory = async () => {
    setIsLoading(true)

    await axios
      .get(Constant.getAPI() + '/admin/list-vouchers', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        params: {
          name: filter.name,
          country: filter.country,
          code: filter.code,
          created_by: filter.created_by,
          redeemed_by: filter.redeemed_by,
          start_date: filter.start_date,
          end_date: filter.end_date,
        },
      })
      .then((res) => {
        if (res.data.success) {
          setList(res?.data?.data || [])
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const loadCountries = async () => {
    await axios
      .get(Constant.getAPI() + '/multi-country/list-countries?show_all_countries=true', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name:
            localStorage.getItem('loged_In_role') === 'super-admin'
              ? ''
              : `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          setCountries(res?.data?.data || [])
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  const handleFilterChange = (event) => {
    setFilters({
      ...filter,
      [event?.target?.name]: event?.target?.value,
    })
  }

  const clearSearch = () => {
    setFilters({
      country: localStorage.getItem('countryShortName') || 'KWT',
      name: '',
      code: '',
      created_by: '',
      redeemed_by: '',
      start_date: '',
      end_date: '',
    })

    setList([])
  }

  const columns = [
    {
      name: 'id',
      label: 'id',
      options: {
        sort: true,
        display: false,
      },
    },
    {
      name: 'name',
      label: 'Name',
      options: {
        sort: true,
        customBodyRender: (value) => {
          return value || '--'
        },
      },
    },
    {
      name: 'code',
      label: 'Code',
      options: {
        sort: true,
      },
    },
    {
      name: 'amount',
      label: 'Amount',
      options: {
        sort: true,
      },
    },
    {
      name: 'created_at',
      label: 'Created At',
      options: {
        sort: true,
        customBodyRender: (data) => {
          return data ? (
            <div style={{ textWrap: 'nowrap' }}>
              <Moment format="YYYY-MM-DD hh:mm:ss A">{data}</Moment>
            </div>
          ) : (
            '--'
          )
        },
      },
    },
    {
      name: 'voucher_creator',
      label: 'Created By',
      options: {
        sort: false,
        customBodyRender: (obj) => {
          return (
            <div style={{ textWrap: 'nowrap' }}>
              <span>ID: {obj?.id || '--'}</span>
              <br />
              <span>Email: {obj?.email || '--'}</span>
              <br />
              <span>
                Phone: {obj?.country_code} {obj?.phone || '--'}
              </span>
            </div>
          )
        },
      },
    },
    {
      name: 'voucher_user',
      label: 'Redeemed By',
      options: {
        sort: false,
        customBodyRender: (obj) => {
          return (
            <div style={{ textWrap: 'nowrap' }}>
              <span>ID: {obj?.id || '--'}</span>
              <br />
              <span>Email: {obj?.email || '--'}</span>
              <br />
              <span>
                Phone: {obj?.country_code} {obj?.phone || '--'}
              </span>
            </div>
          )
        },
      },
    },
    {
      name: 'is_redeemed',
      label: 'Redeemed',
      options: {
        sort: false,
        customBodyRender: (value) => {
          return <span>{value == true ? 'Yes' : 'No'}</span>
        },
      },
    },
    {
      name: 'is_active',
      label: 'Active',
      options: {
        sort: true,
        customBodyRender: (isActive) => {
          return isActive ? 'Yes' : 'No'
        },
      },
    },
    {
      name: 'country',
      label: 'Country',
      options: {
        sort: true,
      },
    },
  ]
  const options = {
    filter: false,
    download: true,
    downloadOptions: {
      filename: 'VoucherList',
    },
    onDownload: (buildHead, buildBody, columns, values) => {
      const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
      const fileExtension = '.xlsx'
      const fileName = `VoucherList`

      const json = values.reduce((result, val) => {
        const temp = {}
        val.data.forEach((v, idx) => {
          if (columns[idx].name == 'created_at') {
            temp['Created At'] = moment(v)
              .tz(getCountryTimeZone(localStorage.getItem('countryShortName')))
              .format('YYYY-MM-DD hh:mm:ss A')
          } else if (columns[idx].name == 'voucher_creator') {
            temp['Created by User ID'] = v?.id
            temp['Created by User Email'] = v?.email
            temp['Created by User Phone'] = v?.phone ? v?.country_code + ' ' + v?.phone : ''
          } else if (columns[idx].name == 'voucher_user') {
            temp['Redeemed by User ID'] = v?.id
            temp['Redeemed by User Email'] = v?.email
            temp['Redeemed by User Phone'] = v?.phone ? v?.country_code + ' ' + v?.phone : ''
          } else if (columns[idx].name == 'is_redeemed') {
            temp[columns[idx].label] = v ? 'Yes' : 'No'
          } else if (columns[idx].name == 'is_active') {
            temp[columns[idx].label] = v ? 'Yes' : 'No'
          } else {
            temp[columns[idx].label] = v
          }
        })
        result.push(temp)
        return result
      }, [])

      const ws = utils.json_to_sheet(json)
      const wb = { Sheets: { data: ws }, SheetNames: ['data'] }
      const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' })
      const blob = new Blob([excelBuffer], { type: fileType })
      const file = new File([blob], fileName + fileExtension, { type: fileType })

      const downloadLink = document.createElement('a')
      downloadLink.href = URL.createObjectURL(file)
      downloadLink.download = file.name

      downloadLink.click()

      // cancel default  CSV download from table
      return false
    },
    search: false,
    viewColumns: false,
    print: false,
    selectableRows: 'none',
    textLabels: {
      body: {
        noMatch: isLoading ? 'Loading data..!' : 'Sorry, No Data Found',
        toolTip: 'Sort',
        columnHeaderTooltip: (column) => `Sort for ${column.label}`,
      },
    },
  }

  return (
    <>
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Voucher Report</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Voucher Report</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card card-border-default">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Country</label>
                            <div className="col-sm-9">
                              <select
                                name="country"
                                className="form-control"
                                value={filter.country}
                                onChange={handleFilterChange}
                              >
                                {countries.map((country) => (
                                  <option
                                    value={country.country_short_name}
                                    key={country.country_short_name}
                                  >
                                    {country.country_name_en + '/' + country.country_name_ar}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Created By User</label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                name="created_by"
                                className="form-control"
                                onChange={handleFilterChange}
                                value={filter.created_by}
                                placeholder="Search - User Id | Email | Phone"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Redeemed By User</label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                name="redeemed_by"
                                className="form-control"
                                onChange={handleFilterChange}
                                value={filter.redeemed_by}
                                placeholder="Search - User Id | Email | Phone"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Trans Start Date</label>
                            <div className="col-sm-9">
                              <input
                                type="date"
                                name="start_date"
                                className="form-control"
                                onChange={handleFilterChange}
                                value={filter.start_date}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Trans End Date</label>
                            <div className="col-sm-9">
                              <input
                                type="date"
                                max={moment().format('YYYY-MM-DD')}
                                name="end_date"
                                className="form-control"
                                onChange={handleFilterChange}
                                value={filter.end_date}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Voucher name</label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                name="name"
                                className="form-control"
                                onChange={handleFilterChange}
                                value={filter.name}
                                placeholder="Search - Voucher name"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Voucher code</label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                name="code"
                                className="form-control"
                                onChange={handleFilterChange}
                                value={filter.code}
                                placeholder="Search - Voucher code"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="row">
                            <div
                              className="col-6"
                              style={{ color: 'red' }}
                            >
                              {/* You can get maximum 6 months rocords at a time */}
                            </div>
                            <div className="text-right col-6">
                              {isLoading ? (
                                <button
                                  className="btn btn-grd-disabled"
                                  disabled
                                  style={{ width: 150 }}
                                >
                                  Searching...!
                                </button>
                              ) : (
                                <>
                                  <button
                                    style={{ width: 150 }}
                                    className="btn btn-inverse waves-effect m-r-10"
                                    onClick={clearSearch}
                                  >
                                    Clear
                                  </button>
                                  <button
                                    style={{ width: 150 }}
                                    onClick={loadVoucherHistory}
                                    className="btn btn-inverse waves-effect"
                                  >
                                    Search
                                  </button>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-12">
                  <div className="card card-border-default">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        <MUIDataTable
                          title={'Report'}
                          className="table-responsive"
                          data={list}
                          columns={columns}
                          options={options}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default VoucherReport
